<script>
import UsageGuage from './usage-guage.vue'
  //base template until snippet setup
  export default {
    name: '',
    components: {UsageGuage},
    props: {
      company: {
        type: Object,
        default: () => ({})
      },
      consumptionRate: {
        type: String | Number,
        default: () => ''
      },
      isPreview: {
        type: Boolean,
        default: () => false
      },
      options: {
          type: Object,
        default: () => ({})
      },
      scale: {
        type: String | Number,
        default: () => 1
      },
      title1: {
        type: String,
        default: () => ''
      },
      title2: {
        type: String,
        default: () => ''
      },
      title3: {
        type: String,
        default: () => ''
      },
      titleSavings: {
        type: String,
        default: () => ''
      },
      trailers: {
        type: Array,
        default: () => ([])
      },
      // trailers: {
      //   type: Object,
      //   default: () => ({})
      // },
      usageRange: {
        type: Array,
        default: () => []
      },
      usageStats: {
        type: Object,
        default: () => {}
      }
    },
    data: () => ({
      savingsCards: [
        {
          id: '1',
          img: '/img/fuel_container.png',
          text: 'At least # gallons of diesel',
          statsKey: 'gallonsFuelSaved'
        },
        {
          id: '2',
          img: '/img/money_hand.png',
          text: "That's # in cash!",
          statsKey: 'fuelCostSaved'
        },
        {
          id: '3',
          img: '/img/power_plant.png',
          text: '# Metric tons of CO2 from out air',
          statsKey: 'co2Prevented'
        },
        {
          id: '4',
          img: '/img/tree.png',
          text: '# Trees free to make our air even cleaner',
          statsKey: 'treesSaved'
        },
      ]
    }),
    computed: {
      contactValues() {
        const contact = this.company
        const values =  []


        if (contact?.first_name?.length || contact?.last_name?.length) {
          values.push(`${contact?.first_name || ''} ${contact?.last_name || ''}`)
        } else if (this.isPreview) {
          values.push('CONTACT NAME')
        }
        const keys =
        [
        {
          key: 'phone_mobile',
          label: 'm',
          default: '(555) 555 5555'
        },
        {
          key: 'phone_office',
          label: 'o',
          default: '(555) 555 5555'
        },
        {
          key: 'email',
          label: 'e',
          default: 'email@example.com'
        },
      ]
        keys.forEach(k => {
          if (contact?.[k.key]) {
            values.push(`${k.label}:  ${contact[k.key]}`)
          } else if (this.isPreview) {
            values.push(`${k.label}:  ${k.default}`)
          }
        })
return values
      }
    },
    methods: {
      companyGeneratorImg() {
        return `${process.env.VUE_APP_MEDIA_URL}logos/${this.company.generator}`
      },
      companyLogoImg() {
        return `${process.env.VUE_APP_MEDIA_URL}logos/${this.company.logo}`
      },
      percentageText(percentage = 0) {
        console.log(percentage)
        return percentage
        const percent = parseFloat(percentage) * 100

        if (percent > 0 && percent < 1) {
          console.log('----')
          console.log(percent.toFixed(2))
          console.log(parseInt(percent.toFixed(2)))
          return parseInt(percent.toFixed(2))
        }
 return Math.round(parseFloat(percent))
      },
      sortedByvalue(obj) {
        return Object.values(obj).sort((a, b) => a.localeCompare(b))
      }
    },
    created() {

    },
    mounted() {}
  }
</script>
<template>
  <v-card :flat="!isPreview" height="auto" width="100%" class="card" :style="`--scale: ${scale}`">
    <v-card-text class="card-text d-flex pa-4" style="height: 100%">
      <v-sheet height="100%" width="75%" class="left-column d-flex flex-column align-center justify-space-between flex-grow-1 pr-2">
        <v-sheet class="title-container d-flex flex-column align-center">
        <p class="title1-text text-center font-weight-bold mb-0">
          {{ title1 || '' }}
          <!-- {{ title1 || 'COMPANY - ENERGY REPORT' }} -->
        </p>
        <p class="title2-text text-center font-weight-bold mb-0">
          {{ title2 || '' }}
          <!-- {{ title2 || 'DATE START - END' }} -->
        </p>
        <p class="title3-text text-center font-weight-black mb-0">
          {{ title3 || '' }}
          <!-- {{ title3 || '"PROJECT TITLE"' }} -->
        </p>
        </v-sheet>
        <v-sheet width="100%"  class="d-flex align-center justify-space-around mb-0 ">
          <v-sheet  v-if="options?.showRuntimeGauge !== false"  width="50%" class="d-flex flex-column align-center justify-space-around">
            <p class="text-h6 font-weight-bold mb-0">% RUN TIME ON SOLAR & BATTERY</p>
       <usage-guage :percentage="percentageText(usageStats.percentHoursOffGrid)"></usage-guage>
            <!-- <v-sheet class="arc-container">

              <div class="arc-green" style="--a: calc(117deg * 0.79)"></div>
              <div class="arc-red"></div>
              <div class="percentage-text font-weight-bold ">100%</div>
            </v-sheet> -->
            <!-- <v-progress-circular color="green" class="mt-2"></v-progress-circular> -->
            <v-sheet>
              <p class="text-body-2 text-left font-weight-bold mb-0">TOTAL RUN TIME - {{usageStats.reportedHours}} HOURS</p>
              <p class="text-body-2 text-left font-weight-bold mb-0">TIME ON SOLAR/BATTERY - {{usageStats.hoursOffGrid }} {{`HOUR${usageStats.timeOnSolar  == "1" ? '' : 'S'}`}}</p>
              <p class="text-body-2 text-left font-weight-bold mb-0">TIME ON EXTERNAL POWER - {{usageStats.hoursOnGrid}} {{`HOUR${usageStats.timeOnExternal  == "1" ? '' : 'S'}`}}</p>
            </v-sheet>
          </v-sheet>
          <v-sheet  v-if="options?.showPercentSolarGauge !== false" width="50%" class="d-flex flex-column align-center justify-space-around">
            <p class="text-h6 font-weight-bold mb-0">% POWER FROM SOLAR</p>
         <usage-guage :percentage="percentageText(usageStats.percentOffGrid)"></usage-guage>
            <!-- <v-progress-circular color="green" class="mt-2"></v-progress-circular> -->
            <v-sheet>
              <p class="text-body-2 text-left font-weight-bold mb-0">TOTAL KILOWATT HOURS USED - {{usageStats.totalkWh}}</p>
              <p class="text-body-2 text-left font-weight-bold mb-0">SOLAR GENERATED KWH'S - {{usageStats.offGridkWh}}</p>
              <p class="text-body-2 text-left font-weight-bold mb-0">KILOWATTS FROM DIESEL/GRID POWER - {{usageStats.gridkWh}}</p>
            </v-sheet>
          </v-sheet>
        </v-sheet>

        <v-sheet width="100%"  class="d-flex flex-column align-center justify-space-around mb-0 ">
        <p class="text-left text-h4 black--text font-weight-black mt-8 mb-2">
          {{titleSavings || ''}}
          <!-- {{titleSavings || 'YOU SAVED THIS WEEK!'}} -->
        </p>
        <v-sheet width="100%" class="d-flex align-center justify-space-around mb-0">
            <v-card v-for="card in savingsCards" :key="card.id" flat height="200px" width="25%" class="d-flex flex-column align-center justify-start pa-4">
             <v-sheet height="100px">
              <img :src="card.img" class="savings-img"></img>

             </v-sheet>
            <p class="font-weight-black mb-0 mt-2 text-uppercase">{{card.text.replace('#', usageStats?.[card.statsKey] || '-')}}</p>
            </v-card>
        </v-sheet>
        </v-sheet>

            <v-sheet>
              <p class="sub-text text-left font-weight-bold"  style="text-decoration-color: black">GALLONS OF DIESEL SAVED BASED ON AVERAGE USE OF {{consumptionRate}} GALLONS PER HOUR <a class="black--text text-decoration-underline" href="https://www.multiquip.com/multiquip/pdfs/SG1400C4F_Data_Sheet.pdf" target="_blank">(MINIMUM RECORDED OF GENERATOR)</a> </p>
              <p class="sub-text text-left font-weight-bold"  >CASH SAVINGS BASED ON <a class="black--text text-decoration-underline" href="https://www.eia.gov/petroleum/gasdiesel/" target="_blank
              " style="text-decoration-color: black !important;">U.S. EIA FUEL COST REPORTING</a></p>
              <p class="sub-text text-left font-weight-bold"  style="text-decoration-color: black">CARBON EQUIVALENTS CALCULATED USING <a class="black--text text-decoration-underline"  style="text-decoration-color: black" href="https://www.eia.gov/environment/emissions/co2_vol_mass.php" target="_blank
              "><span class="text-decoration-underline" style="text-decoration-color: black">U.S. ENERGY INFORMATION ADMINISTRATION</span></a> </p>
              <!-- <p class="sub-text text-left font-weight-bold mb-0">TREE EQUIVALENCY BASED ON <a class="black--text text-decoration-underline" href="https://www.encon.eu/en/calculation-co2-offsetting-trees" target="_blanks"> 39 TREES PER METRIC TON </a></p> -->
              <p class="sub-text text-left font-weight-bold">TREE EQUIVALENCY BASED ON 39 TREES PER METRIC TON</p>
            </v-sheet>
      </v-sheet>

      <v-sheet min-height="100%" width="25%" class="right-column d-flex flex-column align-start justify-start ml-4"
        >
        <!-- LOGO -->
        <v-sheet v-if="options?.showLogo !== false" class="company-logo-container">
        <img  :src="company?.logo ? companyLogoImg() :  '/img/solar-power-green.png'" class="company-logo"></img>
        </v-sheet>

        <!-- CONTACT CARD -->
<v-card v-if="options?.showContact !== false && contactValues?.length"  width="100%" class="contact-card mt-4">
<v-card-text class="text-left px-4 py-2">
  <p v-for="(contact, k) in contactValues" :key="k" class="font-weight-bold text-caption black--text text-uppercase mb-0">{{contact}}</p>
</v-card-text>
</v-card>

        <!-- TRAILERS -->
        <v-sheet  v-if="options?.showTrailers !== false" class="trailers-text d-flex flex-wrap align-start mb-0 mt-4">
          <div class="font-weight-bold mr-4 mt-4">SOLAR TRAILERS USED:</div>
          <ul>
            <li v-for="trailer in trailers" :key="trailer" class="text-left mt-1">
              {{ trailer?.trim() || '' }}
              <!-- {{ `• ${trailer}` }} -->
            </li>
            <!-- <li v-for="(trailer, id) in sortedByvalue(trailers)" :key="id" class="text-left mt-1">
              {{ trailer?.trim() || '' }}
            </li> -->
          </ul>
        </v-sheet>
        <!-- GENERATOR "AD" -->

<v-card  v-if="options?.showGenerator !== false" flat width="100%" class="contact-card mt-auto">
<v-card-text class="text-left px-2 py-2">
  <p class="power-station-text text-caption text-left black--text font-weight-bold mt-1 mb-4">STAY OFF THE GRID EVEN LONGER WITH ELECTRICAL POWER STATIONS!</p>
 <!-- <img  :src="'/img/solar_generator.png'" alt="SOLAR ELECTRICAL POWER STATION" class="power-station-img"> -->
 <img  :src="company?.generator ? companyGeneratorImg() : '/img/solar_generator.png'" alt="SOLAR ELECTRICAL POWER STATION" class="d-block power-station-img mx-auto">
</v-card-text>
</v-card>


      </v-sheet>
    </v-card-text>
  </v-card>
</template>

<style scoped>

  .card {
     --heading-height: 140px;
     --green: #4fb594;
     --red: #ff3131;
     --scale: 1;
    aspect-ratio: 1.294/1;
    height: 100%;
    max-width: 11in;
    min-width: 11in;
    max-height: 8.3in;
    overflow: hidden;
    /* min-height: 8.5in; */
    transform: scale(var(--scale));
    transform-origin: top left;
    width: 100%;

  }
  .card-text {
    align-items: stretch;
  }
  .left-column {
    /*overflow:hidden;*/
  }

  .title-container {
    height: var(--heading-height);
    white-space: nowrap;
  }

  .title1-text {
    font-size: 2rem;
    /* font-size: 4cqi; */
    line-height: 1.1;
    width: fit-content;
  }
  .title2-text {
    font-size: 1.5rem;
    /* font-size: 4cqi; */
    line-height: 1.1;
    width: fit-content;
    text-wrap: wrap;
  }
  .title3-text {
    font-size: 3rem;
    /* font-size: 4cqi; */
    line-height: 1.1;
    width: fit-content;
  }

  .company-logo-container {
    height: calc(var(--heading-height) + 20px);
  align-self: center;

  }

.company-logo {
  display: block;
  width: auto;
  height:  auto;
  max-height: 100%;
  aspect-ratio: 1/1;
  object-fit: contain;
}

.contact-card {
  border: solid 4px var(--green) !important;
  border-radius: 20px;
}

.trailers-container {
  white-space: nowrap;
  container-type: inline-size;
}

  .trailers-text {
    font-size: 1rem;
    /* font-size: 1.75cqi; */
    line-height: 1;
  }


  .arc-container {
    position: relative;
    height: 100px;
    width: 200px;
    scale: 75%;
  }

  .percentage-text {
    position: absolute;
    bottom: 4px;
    left: 50%;
    font-size: 1.75rem;
    transform: translate(-50%, -50%);
  }
  .arc-green {
    --b: 30px; /* the boder thickness */
    --a: 126deg; /* control the progression */
    position: absolute;
    top: 10px;
    width: 200px;
    aspect-ratio: 1;
    padding: var(--b);
    box-sizing: border-box;
    border-radius: 50%;
    background: var(--green);
    z-index: 2;

    /* background: linear-gradient(green 70%, red 20%);
    */
    --_g: /var(--b) var(--b) no-repeat radial-gradient(50% 50%, #000 calc(100% - 1px), #0000);
    mask: top var(--_g), calc(50% + 50% * sin(var(--a))) calc(50% - 50% * cos(var(--a))) var(--_g), linear-gradient(#0000 0 0) content-box intersect,
      conic-gradient(#000 var(--a), #0000 0);
    rotate: -62deg;
  }
  .arc-red {
    --b: 30px; /* the boder thickness */
    --a: 117deg; /* control the progression */
    position: absolute;
    top: 10px;
    width: 200px;
    aspect-ratio: 1;
    padding: var(--b);
    box-sizing: border-box;
    border-radius: 50%;
    background: var(--red);

    /* background: linear-gradient(green 70%, red 20%);
    */
    --_g: /var(--b) var(--b) no-repeat radial-gradient(50% 50%, #000 calc(100% - 1px), #0000);
    mask: top var(--_g), calc(50% + 50% * sin(var(--a))) calc(50% - 50% * cos(var(--a))) var(--_g), linear-gradient(#0000 0 0) content-box intersect,
      conic-gradient(#000 var(--a), #0000 0);
    rotate: -58deg;
  }

  /* @container (min-width: 800px) {
    .title-text {
      font-size: max(1.5em, 1.23em + 2cqi);
    }
  } */
  /*
  @container (min-width: 400px) {
    .title-text {
      font-size: 28px;
    }
  }*/

  .savings-img{
    max-height: 100px;
    width: auto;
    object-fit: contain;
  }

.sub-text{
  font-size: 10px;
  line-height: 1.35;
  margin-bottom: 0px;
  /* margin-top: 2px; */
}

.power-station-text {
  line-height: 1;
}

.power-station-img {
  width: auto;
  height: 100%;
  max-height: 130px;
  border-radius: 5px;
}


</style>
<style>
  @page {
    size: letter landscape;
    margin: 0px;
    padding: 0px;
  }
</style>
